import React, { Component } from 'react';
import {
    Dialog, DialogContent, Typography, Button, FormControl, InputLabel,
    Select, MenuItem, CircularProgress, Divider, IconButton
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import * as adminBillingService from '../../services/admin-billing.service';

const styles = {
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '20px 24px 12px',
    },
    content: {
        padding: '16px 24px 24px',
    },
    footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 8,
        padding: '12px 24px 16px',
        backgroundColor: '#f5f5f5',
        borderTop: '1px solid #e0e0e0',
    },
    planItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
    },
};

class ConvertPlanDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            plans: [],
            selectedPlanPeriodicityId: '',
            loading: true,
            error: null
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.open && !prevProps.open) {
            this.loadPlans();
        }
    }

    loadPlans() {
        this.setState({ loading: true, error: null, selectedPlanPeriodicityId: '' });
        adminBillingService.getActivePlans(this.props.includeTrial || false)
            .then(result => {
                if (result.data.success) {
                    const plans = result.data.data || [];
                    this.setState({ plans, loading: false });
                } else {
                    this.setState({
                        error: result.data.errors ? result.data.errors[0] : 'Erro ao carregar planos',
                        loading: false
                    });
                }
            })
            .catch(err => {
                const msg = err.response && err.response.data && err.response.data.errors
                    ? err.response.data.errors[0]
                    : 'Erro ao carregar planos. Verifique a conexão.';
                this.setState({ error: msg, loading: false });
            });
    }

    handleChange = (e) => {
        this.setState({ selectedPlanPeriodicityId: e.target.value });
    }

    handleConfirm = () => {
        if (this.props.onConfirm && this.state.selectedPlanPeriodicityId) {
            this.props.onConfirm(this.state.selectedPlanPeriodicityId);
        }
    }

    handleClose = () => {
        this.setState({ selectedPlanPeriodicityId: '', error: null });
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    getSelectedPlan() {
        return this.state.plans.find(p => p.id === this.state.selectedPlanPeriodicityId);
    }

    render() {
        const { open, title } = this.props;
        const { plans, selectedPlanPeriodicityId, loading, error } = this.state;
        const selectedPlan = this.getSelectedPlan();

        return (
            <Dialog
                open={open}
                onClose={this.handleClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    style: { borderRadius: 12, overflow: 'hidden' }
                }}
            >
                {/* Header */}
                <div style={styles.header}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <SwapHorizIcon style={{ fontSize: 28, color: '#1976d2', marginRight: 12 }} />
                        <div>
                            <Typography variant="h6" style={{ fontWeight: 600, fontSize: 18 }}>
                                {title || 'Converter Plano'}
                            </Typography>
                            <Typography variant="body2" style={{ color: '#757575', marginTop: 2 }}>
                                Selecione o plano de destino para a conversão
                            </Typography>
                        </div>
                    </div>
                    <IconButton size="small" onClick={this.handleClose} style={{ color: '#9e9e9e' }}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </div>

                <Divider />

                {/* Content */}
                <DialogContent style={styles.content}>
                    {loading ? (
                        <div style={{ textAlign: 'center', padding: 32 }}>
                            <CircularProgress size={36} />
                            <Typography variant="body2" style={{ marginTop: 12, color: '#757575' }}>
                                Carregando planos disponíveis...
                            </Typography>
                        </div>
                    ) : error ? (
                        <div style={{
                            textAlign: 'center', padding: 24,
                            backgroundColor: '#fef2f2', borderRadius: 8, border: '1px solid #fecaca'
                        }}>
                            <Typography style={{ color: '#dc2626', fontWeight: 500 }}>{error}</Typography>
                            <Button
                                size="small"
                                color="primary"
                                onClick={() => this.loadPlans()}
                                style={{ marginTop: 8, textTransform: 'none' }}
                            >
                                Tentar novamente
                            </Button>
                        </div>
                    ) : (
                        <>
                            <FormControl fullWidth variant="outlined" style={{ marginTop: 8 }}>
                                <InputLabel>Plano</InputLabel>
                                <Select
                                    value={selectedPlanPeriodicityId}
                                    onChange={this.handleChange}
                                    label="Plano"
                                >
                                    {plans.map(plan => (
                                        <MenuItem key={plan.id} value={plan.id}>
                                            <div style={styles.planItem}>
                                                <span>[ID: {plan.id}] {plan.planname} - {plan.periodicityname}</span>
                                                <span style={{ color: '#1976d2', fontWeight: 600, marginLeft: 16 }}>
                                                    R$ {plan.value ? plan.value.toFixed(2) : '0,00'}/mês
                                                </span>
                                            </div>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {selectedPlan && (
                                <div style={{
                                    marginTop: 16, padding: 16,
                                    backgroundColor: '#f0f7ff', borderRadius: 8, border: '1px solid #bbd6f7'
                                }}>
                                    <Typography variant="body2" style={{ color: '#1565c0', fontWeight: 500 }}>
                                        Plano selecionado
                                    </Typography>
                                    <Typography variant="body1" style={{ fontWeight: 600, marginTop: 4 }}>
                                        [ID: {selectedPlan.id}] {selectedPlan.planname} - {selectedPlan.periodicityname}
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#424242', marginTop: 2 }}>
                                        Valor: R$ {selectedPlan.value ? selectedPlan.value.toFixed(2) : '0,00'} / mês
                                    </Typography>
                                </div>
                            )}
                        </>
                    )}
                </DialogContent>

                {/* Footer */}
                <div style={styles.footer}>
                    <Button
                        onClick={this.handleClose}
                        style={{ textTransform: 'none', fontWeight: 500, padding: '8px 24px' }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={this.handleConfirm}
                        variant="contained"
                        disabled={!selectedPlanPeriodicityId || loading}
                        style={{
                            backgroundColor: selectedPlanPeriodicityId ? '#1976d2' : undefined,
                            color: selectedPlanPeriodicityId ? '#fff' : undefined,
                            textTransform: 'none',
                            fontWeight: 600,
                            padding: '8px 28px',
                            borderRadius: 6,
                            boxShadow: selectedPlanPeriodicityId ? '0 2px 8px rgba(0,0,0,0.15)' : 'none',
                        }}
                    >
                        Confirmar Conversão
                    </Button>
                </div>
            </Dialog>
        );
    }
}

export default ConvertPlanDialog;
